// ============================================================================
// POLSKIE TŁUMACZENIA - JEZUS NIE JEST...
// ============================================================================
// Ważne wyjaśnienia dotyczące tego, kim naprawdę jest Jezus

export const jesusIsNot = [
  {
    "category": "miłość",
    "text": "Jezus nie jest homofobem - Jego nieskończona miłość obejmuje każdego takim, jakim jest",
    "reference": "1 Jana 4:8 - Bóg jest miłością",
    "context": "Miłość Boga jest inkluzywna i akceptuje każdą osobę w jej różnorodności"
  },
  {
    "category": "równość",
    "text": "Jezus nie jest mizoginistą - Jego nieskończona miłość ceni każdą kobietę",
    "reference": "Łukasza 8:1-3 - Kobiety, które podążały za Jezusem",
    "context": "Jezus rewolucjonizuje swoje czasy, włączając i honorując kobiety"
  },
  {
    "category": "pokój",
    "text": "Jezus nie jest mordercą - Jego nieskończona miłość daje życie wszystkim",
    "reference": "Jana 10:10 - Przyszedłem, aby mieli życie",
    "context": "Jezus przynosi życie, uzdrowienie i odnowienie każdemu"
  },
  {
    "category": "jedność",
    "text": "Jezus nie jest dzielący - Jego nieskończona miłość jednoczy całą ludzkość",
    "reference": "Galatów 3:28 - Nie ma już Żyda ani Greka",
    "context": "Miłość Jezusa przekracza wszystkie ludzkie bariery"
  },
  {
    "category": "miłość",
    "text": "Jezus nie jest rasistą - Jego nieskończona miłość obejmuje wszystkie kultury",
    "reference": "Mateusza 28:19 - Uczyńcie uczniami wszystkie narody",
    "context": "Miłość Jezusa celebruje różnorodność całej ludzkości"
  },
  {
    "category": "sprawiedliwość",
    "text": "Jezus nie jest ciemiężcą - Jego nieskończona miłość wyzwala i uzdrawia każdego",
    "reference": "Łukasza 4:18 - Posłał mnie, abym ogłosił jeńcom wyzwolenie",
    "context": "Miłość Jezusa przynosi wolność i uzdrowienie wszystkim"
  },
  {
    "category": "pokora",
    "text": "Jezus nie jest dumny - Jego nieskończona miłość służy wszystkim",
    "reference": "Filipian 2:7 - Wyzbył się samego siebie",
    "context": "Miłość Jezusa wyraża się przez pokorę i służbę"
  },
  {
    "category": "przebaczenie",
    "text": "Jezus nie jest mściwy - Jego nieskończona miłość zawsze przebacza",
    "reference": "Łukasza 23:34 - Ojcze, przebacz im, bo nie wiedzą, co czynią",
    "context": "Miłość Jezusa oferuje przebaczenie nawet w cierpieniu"
  },
  {
    "category": "współczucie",
    "text": "Jezus nie jest nieczuły - Jego nieskończona miłość odczuwa każdy ból",
    "reference": "Jana 11:35 - Jezus zapłakał",
    "context": "Miłość Jezusa głęboko dzieli nasze radości i smutki"
  },
  {
    "category": "prawda",
    "text": "Jezus nie jest kłamcą - Jego nieskończona miłość jest czystą prawdą",
    "reference": "Jana 14:6 - Ja jestem drogą i prawdą, i życiem",
    "context": "Miłość Jezusa jest najprawdziwszą prawdą, jaka istnieje"
  },
  {
    "category": "pokój",
    "text": "Jezus nie jest gwałtowny - Jego nieskończona miłość przynosi prawdziwy pokój",
    "reference": "Mateusza 5:9 - Błogosławieni, którzy wprowadzają pokój",
    "context": "Miłość Jezusa przekształca konflikty w pojednanie"
  },
  {
    "category": "hojność",
    "text": "Jezus nie jest skąpy - Jego nieskończona miłość daje bez miary",
    "reference": "2 Koryntian 8:9 - Dla was stał się ubogi",
    "context": "Miłość Jezusa jest hojna do punktu dawania wszystkiego"
  },
  {
    "category": "miłość",
    "text": "Jezus nie jest stronniczy - Jego nieskończona miłość przyjmuje każdą unikalną istotę",
    "reference": "Dzieje 10:34 - Bóg nie ma względu na osoby",
    "context": "Miłość Jezusa celebruje wyjątkowość każdej osoby, włącznie z niepełnosprawnością"
  },
  {
    "category": "uniwersalność",
    "text": "Jezus nie ma granic - Jego nieskończona miłość przekracza wszystkie limity",
    "reference": "Rzymian 10:12 - Nie ma różnicy między Żydem a Grekiem",
    "context": "Dla Jezusa nie ma granic: ani geograficznych, ani kulturowych, ani społecznych"
  },
  {
    "category": "szacunek",
    "text": "Jezus nie jest lekceważący - Naucza szacunku dla siebie, kobiet, innych",
    "reference": "Mateusza 22:39 - Będziesz miłował bliźniego swego jak siebie samego",
    "context": "Szacunek to pewna mądrość: szanuj swoje życie, swoje ciało, kobiety jak siebie, innych"
  },
  {
    "category": "pokój",
    "text": "Jezus nie jest dzielący - Jednoczy Żydów, Arabów i wszystkie wyznania w pokoju",
    "reference": "Efezjan 2:14 - On jest naszym pokojem, który uczynił z dwóch jedno",
    "context": "Świętujmy naszą różnorodność zamiast czynić z niej spory słowne i wojny"
  },
  {
    "category": "prawda",
    "text": "Jezus nie jest kłamcą - Demaskuje kłamstwa i manipulację",
    "reference": "Jana 8:44 - Diabeł jest ojcem kłamstwa",
    "context": "Jezus ujawnia kłamstwa i manipulacje, które ranią dusze"
  },
  {
    "category": "hojność",
    "text": "Jezus nie jest chciwy - Jego hojność daleko przewyższa dziesięcinę",
    "reference": "Łukasza 21:3 - Ta uboga wdowa dała więcej niż wszyscy",
    "context": "Hojność Jezusa jest silniejsza niż obowiązek dziesięciny"
  },
  {
    "category": "sprawiedliwość",
    "text": "Jezus nie jest współwinny milczenia - Chroni przez zdrową sprawiedliwość",
    "reference": "Mateusza 18:6 - Kto by zgorszył jednego z tych małych",
    "context": "Milczenie, które kryje winy bez ochrony innych, nie jest mądrością Jezusa"
  }
];

export default jesusIsNot;
